import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export const useUpdateCustomerLogo = (customerId: number) => {
  const queryClient = useQueryClient();

  const updateCustomerLogo = async (logoFile: File) => {
    const formData = new FormData();
    formData.append('logo', logoFile);

    await Axios.patch(
      `${POST_URL(customerId.toString()).updateLogo}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
  };

  return useMutation<void, AxiosError<BaseError>, File>(updateCustomerLogo, {
    onSuccess: () => {
      queryClient.invalidateQueries(['customerLogo', 'customer', customerId]);
    },
    useErrorBoundary: false
  });
};
